import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { SmartPowerReportData } from '../smart-power-report.model';
import { SmartPowerReportActions, SmartPowerReportActionTypes } from '../actions/smart-power-report.actions';

export interface State {
  isLoaded: boolean;
  isLoading: boolean;
  entities: any;
}

export const initialState: State = {
  isLoaded: false,
  isLoading: false,
  entities: null
};
export interface SmartPowerReportState {
  isLoaded: boolean;
  isLoading: boolean;
  entities: any;
}

export const initialSmartPowerReportState: SmartPowerReportState = {
  isLoaded: false,
  isLoading: false,
  entities: null
};
export interface SmartPowerReportDataState {
  isLoaded: boolean;
  isLoading: boolean;
  entities: any;
}

export const initialSmartPowerReportDataState: SmartPowerReportDataState = {
  isLoaded: false,
  isLoading: false,
  entities: null
};

export function reducer(
  state = initialState,
  action: SmartPowerReportActions
): State {
  switch (action.type) {

    case SmartPowerReportActionTypes.GetSmartPowerReportList: {
      return { ...state, isLoaded: false, isLoading: true };
    }

    case SmartPowerReportActionTypes.UpsertSmartPowerReportList: {
      return { ...state, isLoaded: true, isLoading: false, entities: action.payload };
    }

    case SmartPowerReportActionTypes.GetSmartPowerReportListFail: {
      return { ...state, isLoaded: true, isLoading: false, entities: action.payload };
    }

    default: {
      return state;
    }
  }
}

export function smartPowerReportReducer(
  state = initialSmartPowerReportState,
  action: SmartPowerReportActions
): SmartPowerReportState {
  switch (action.type) {

    case SmartPowerReportActionTypes.GetSmartPowerReport: {
      return { ...state, isLoaded: false, isLoading: true };
    }

    case SmartPowerReportActionTypes.UpsertSmartPowerReport: {
      return { ...state, isLoaded: true, isLoading: false, entities: action.payload };
    }

    case SmartPowerReportActionTypes.GetSmartPowerReportFail: {
      return { ...state, isLoaded: true, isLoading: false, entities: action.payload };
    }

    default: {
      return state;
    }
  }
}

export function smartPowerReportDataReducer(
  state = initialSmartPowerReportDataState,
  action: SmartPowerReportActions
): SmartPowerReportDataState {
  switch (action.type) {

    case SmartPowerReportActionTypes.GetSmartPowerReportData: {
      return { ...state, isLoaded: false, isLoading: true };
    }

    case SmartPowerReportActionTypes.UpsertSmartPowerReportData: {
      return { ...state, isLoaded: true, isLoading: false, entities: action.payload };
    }

    case SmartPowerReportActionTypes.GetSmartPowerReportDataFail: {
      return { ...state, isLoaded: true, isLoading: false, entities: action.payload };
    }

    default: {
      return state;
    }
  }
}

export const getSmartPowerReportListState = (state: State) => state;
export const getSmartPowerReportState = (state: SmartPowerReportState) => state;
export const getSmartPowerReportDataState = (state: SmartPowerReportDataState) => state;
